import { render, staticRenderFns } from "./TranslateModals.vue?vue&type=template&id=af7fe634"
import script from "./TranslateModals.vue?vue&type=script&lang=js"
export * from "./TranslateModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports